export const dateRangeOptions = [
    { label: "Last 7 Days", value: "last7d" },
    { label: "Last 14 Days", value: "last14d" },
    { label: "Last 30 Days", value: "last30d" },
];

export const comparisonPeriodOptions = [
    { label: "Prev. Period", value: "previous_period" },
    { label: "Last Year", value: "last_year" },
];